import { useContext } from 'react';
import { useTheme } from '@material-ui/core';
import { languageSelection } from '../components/MapRightDrawer/LanguageSection';
import { LanguageContext } from '../contexts/LanguageContext/languageContext';

export const useLanguage = () => {
  const { language, setLanguage, supportedLanguages } = useContext(LanguageContext); 
  const theme = useTheme();

  const items = languageSelection({
    allowedLanguages: supportedLanguages,
    currentLanguage: language,
    onChange: setLanguage, 
    theme,
  });

  return { items };
};

